















































































































import GenericControl from "@/components/device/configuration/GenericControl.vue";
import Component from "vue-class-component";
import KeyValue from "@/components/KeyValue.vue";
import EditableSelect from "@/components/EditableSelect.vue";
import ExpandButton from "@/components/ExpandButton.vue";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue"
import ToggleInput from '@/components/shared/ToggleInput.vue';
import {Prop, Vue} from "vue-property-decorator";
import {ConfigurationProfileHelper} from "@/components/device/configuration/ConfigurationProfileHelper";
import {nsenDeviceConfigurationProfile} from "@/components/device/configuration/nsen/NsenProfile";
import _ from "lodash";
import {curGroupService, GroupConfigurationParameter} from "@/services/GroupService";

@Component({
  components: {
    KeyValue,
    EditableSelect,
    ExpandButton,
    GenericControl,
    ConfirmDialog,
    ToggleInput
  }
})
export default class NsenGroupConfiguration extends GenericControl {
  @Prop({ default: () => '', type: String}) group!:string;
  @Prop({ default: () => {}, type: Object}) bus!:Vue;

  error:string = '';

  expanded:boolean = true;
  configurationProfileHelper = new ConfigurationProfileHelper(nsenDeviceConfigurationProfile);
  newConfiguration = this.configurationProfileHelper.getDeviceUIConfiguration();
  section = this.configurationProfileHelper.getUISections();

  async mounted() {
    try {
      _.forEach(await this.loadGroupConfiguration(this.group), param => {
        if (this.newConfiguration[this.toHex(param.id)]) {
          this.newConfiguration[this.toHex(param.id)]!.value = param.value;
        }
      });
    } finally {
    }

    _.forEach(_.keys(this.section), index => {
      this.section[index].expanded = true;
    });
  }

  async loadGroupConfiguration(groupId: string): Promise<GroupConfigurationParameter[]> {
    this.error = '';
    try {
      const configuration = await curGroupService.loadGroupConfiguration({
        groupId,
      }) as GroupConfigurationParameter[];
      return configuration;
    } catch (err) {
      this.error = (err as Error).message;
      return [];
    }
  }

  revertExtended(id: string) {
    this.section[this.configurationProfileHelper.deviceConfigurationProfile[id].sectionId as string].expanded
        = !this.section[this.configurationProfileHelper.deviceConfigurationProfile[id].sectionId as string].expanded;
  }

  updateOption(id: string, value: string) {
    this.newConfiguration[id]!.value = value;
  }

  async updateConfiguration() {
    this.error = '';
    const formInvalid = _.some(_.keys(this.newConfiguration), id => ! this.isValueInRange(id, this.newConfiguration));
    if (formInvalid) {
      this.error = 'Some values on the form are invalid. Please fix them before submitting !';
      return;
    }
    const paramKeysToUpdate = _.keys(this.newConfiguration);

    if (paramKeysToUpdate.length > 0) {
      const params = _.map(paramKeysToUpdate, key => _.pick(this.newConfiguration[key]!, 'id', 'value'));
      try {
        await curGroupService.sendGroupCommand({
          groupId: this.group,
          command: 'p1',
          params: [{
            id: 0,
            value: Math.floor(Math.random() * 256),
            ignoreUpdateConfiguration: true,
          }, {
            id: 145,
            value: 150,
            ignoreUpdateConfiguration: true,
          }],
        });

        await Promise.all(_.map(params, param => {
          const profile = nsenDeviceConfigurationProfile[`0x${param.id.toString(16)}`];
          return curGroupService.sendGroupCommand({
            groupId: this.group,
            command: (profile && profile.command) ? profile.command : 'p2',
            params: [{
              id: 0,
              value: Math.floor(Math.random() * 256),
              ignoreUpdateConfiguration: true,
            }, {
              id: param.id,
              value: param.value,
            }],
            updateConfiguration: true,
          });
        }));
        this.bus.$emit('refresh');
      } catch (err) {
        this.error = (err as Error).message;
      }
    }

  }

  async resetDevices() {
    this.error = '';
    try {
      await curGroupService.sendGroupCommand({
        groupId: this.group,
        command: 'restart',
        params: [{
          id: 0,
          value: Math.floor(Math.random() * 256),
        }]
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async resetAccumulatedTotals() {
    this.error = '';
    try {
      await curGroupService.sendGroupCommand({
        groupId: this.group,
        command: 'pulrst',
        params: [{
          id: 0,
          value: Math.floor(Math.random() * 256),
          ignoreUpdateConfiguration: true,
        }]
      });

      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async showConfirmUpdateConfigs() {
    (this.$refs.confirmUpdateConfigs as ConfirmDialog).show(this.updateConfiguration);
  }

  async showConfirmResetDevices() {
    (this.$refs.confirmResetDevices as ConfirmDialog).show(this.resetDevices);
  }

  async showConfirmResetAccumulatedTotals() {
    (this.$refs.confirmResetAccumulatedTotals as ConfirmDialog).show(this.resetAccumulatedTotals);
  }
}
